import type { NewsletterModel } from "./NewsletterModel";

export class NewsletterAdapter {
  private newsletterModel: NewsletterModel;

  constructor(newsletterModel: NewsletterModel) {
    this.newsletterModel = newsletterModel;
  }

  async unregisterNewsletter(email: string, companyId: number): Promise<void> {
    return this.newsletterModel.unregisterNewsletter(email, companyId);
  }
}
